import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Pagination, Input, Button, Modal, Empty, Popconfirm, Tooltip, Card } from 'antd';
import { SearchOutlined, CloseOutlined, EyeOutlined } from '@ant-design/icons';
import './DataTable.css';
// import UserProfile from '../../session/UserProfile'
import { AnyCnameRecord } from 'dns';
import { checkAccess, getUserRole } from '../../utilities/CommonHelper';
import { getUserAccessData, getUserDetails } from '../../utilities/sessionHelper';
import Link from 'antd/es/typography/Link';
import { ReloadOutlined, InfoCircleOutlined } from '@ant-design/icons';

const containerStyle:any = {
    maxHeight: '440px',
    overflow: 'auto',
};

const tableStyle:any = {
    width: 'max-content',
    borderCollapse: 'initial',
    overflowX: 'auto'
};

const thStyle:any = {
    position: 'sticky',
    top: '0',
    zIndex: '10'
};
const tdStyle:any = {
    boxShadow: '-5px 0px 5px rgba(255, 255, 255, 1)'
};
const UserProfile= getUserRole(getUserAccessData()?.roleAccessMap);

const itemsPerPage = 10;
function DataTable(props:any) {
    const data = useMemo(() => props.data, [props.data]);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [searchText, setSearchText] = useState<any>({});
    const [openSearch, setOpenSearch] = useState<any>({});
    const [displayedData, setDisplayedData] = useState<any>(data.slice(0, itemsPerPage));
    const [modalVisible, setModalVisible] = useState<any>(false);
    const [modalPosition, setModalPosition] = useState<any>({ top: 0, left: 0 });
    const [expandedScheduleIds, setExpandedScheduleIds] = useState<any>({});
    const toggleScheduleView = (id: any) => setExpandedScheduleIds((prev: any) => ({ ...prev, [id]: !prev[id] }));
    const scheduleTypeLabel = (val: any) => val === 'MONTHLY' ? 'Monthly' : val === 'MILESTONE' ? 'Milestone' : val === 'CUSTOM' ? 'Custom' : '';
    const clickedColumnRef = useRef<any>(null);
    const searchInputRef = useRef<any>(null);
    const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
    const writeAccess_order:boolean=checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"write");
    const writeAccess_poMapping:boolean=checkAccess(role,"PO Mapping",getUserAccessData()?.roleAccessMap[role],"write");
   


    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const filteredData = filterData(); // Calculate filtered data
        setDisplayedData(filteredData.slice(startIndex, endIndex));
        console.log(displayedData);
    }, [data])

    // Function to filter data based on search text
    const filterData = () => {
        const searchValues = Object.values(searchText).map((value:any) => value?.toLowerCase());

        // return (data || []).filter((record:any) =>
        //     Object.keys(searchText).every((column, index) => {
        //         if (searchValues[index] === undefined || searchValues[index] === null || searchValues[index] === '') return true;

        //         if (column === 'bu') {
        //             record.workOrderBuDepartments = record.workOrderBuDepartments?.filter((detail:any) => {
        //                 const found = detail[column]?.toLowerCase().includes(searchValues[index]);
        //                 return found;
        //             });
        //             return record.workOrderBuDepartments && record.workOrderBuDepartments.length > 0;
        //         } else {
        //             return record[column]?.toLowerCase().includes(searchValues[index]);
        //         }
        //     })
        // );

        // const filterData = (data = [], searchText = {}, searchValues = []) => {
        return (data || []).map((record:any) => {
            const filteredRecord = { ...record }; // Create a shallow copy of the record
            // Check if all search criteria match
            const match = Object.keys(searchText).every((column, index) => {
                if (searchValues[index] === undefined || searchValues[index] === null || searchValues[index] === '') return true;

                if (['bu', "department", "subDepartment", 'classCode'].includes(column)) {
                    filteredRecord.workOrderBuDepartments = filteredRecord.workOrderBuDepartments?.filter((detail:any) => {
                        const found = detail[column]?.toLowerCase().includes(searchValues[index]);
                        return found;
                    });
                    return filteredRecord.workOrderBuDepartments && filteredRecord.workOrderBuDepartments.length > 0;
                } else {
                    return filteredRecord[column]?.toString().toLowerCase().includes(searchValues[index]);
                }
            });

            return match ? filteredRecord : null; // Return the filtered record or null if it doesn't match
        }).filter((filteredRecord:any) => filteredRecord !== null); // Remove null entries from the array
        // };






    };

    const handleSearch = (e:any, column:any) => {
        const newSearchText:any = { ...searchText };
        newSearchText[column] = e.target.value;
        setSearchText(newSearchText);
        setCurrentPage(1); // Reset pagination when searching
    };

    const toggleSearchBar = (column:any, event:any) => {
        setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
                if (!searchText[column]) searchInputRef.current.value = '';
            }
        }, 0)
        const columnRect = event.target.getBoundingClientRect();
        const modalWidth = 200; // Set the width of the modal
        const leftSpace = window.innerWidth - columnRect.left; // Calculate the space available on the right side of the clicked element
        const leftPosition = leftSpace > modalWidth ? (columnRect.x - columnRect.y + window.scrollX) : (window.innerWidth - modalWidth + window.scrollX); // Set the left position of the modal based on the available space
        setModalPosition({
            top: 125,
            left: leftPosition < 0 ? 0 : leftPosition,
        });
        setOpenSearch((prevState:any) => ({
            ...prevState,
            [column]: !prevState[column],
        }));
        clickedColumnRef.current = column; // Store the clicked column
        setModalVisible(true);

    };

    const hideModal = () => {
        setModalVisible(false);
    };

    const resetSearch = (searchId:any) => {
        setModalVisible(false);
        delete searchText[searchId];
        console.log('searchText', searchText)
        setSearchText(searchText);
        setCurrentPage(1);
        const filteredData = filterData(); // Calculate filtered data
        console.log('filteredData', filteredData, props.data)
        setDisplayedData(filteredData.slice(0, itemsPerPage));
    };

    const handleChangePage = (page:any) => {
        setCurrentPage(page);
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const filteredData = filterData(); // Calculate filtered data
        setDisplayedData(filteredData.slice(startIndex, endIndex));
    };

    const searchForColumn = (column:any) => {
        console.log('column', column)
        const searchValue:any = searchText[column]?.toLowerCase();
        const filteredData = filterData(); // Calculate filtered data
        console.log('filteredData', filteredData)
        // Apply pagination to the filtered data
        const startIndex = 0;
        const endIndex = Math.min(filteredData.length, itemsPerPage);
        setDisplayedData(filteredData.slice(startIndex, endIndex));

        hideModal();
    };
    const renderSearchColumn = (column:any) => {
        return <th style={thStyle} className="ant-table-column-has-actions ant-table-column-has-filters">
            <span className="ant-table-header-column">
                <div>
                    <span className="ant-table-column-title">
                        {column.name}
                    </span>
                    <SearchOutlined style={{ margin: '10px', color: searchText?.[column.id] ? 'rgb(24, 144, 255)' : 'inherit' }} onClick={(e:any) => toggleSearchBar(column.id, e)}/>
                    {/* <Icon type="search" style={{ margin: '10px', color: searchText?.[column.id] ? 'rgb(24, 144, 255)' : 'inherit' }} onClick={(e:any) => toggleSearchBar(column.id, e)} /> */}
                </div>





            </span>
        </th>
    }
    const placeHolders:any = {
        'id': 'Work Order ID',
        'sowId': 'SOW ID',
        'clientEntity': 'Client Entity',
        'indegeneEntity': 'Indegene Entity',
        'currency': 'Currency',
        'geographyCode': 'Geography Code',
        'nsParentRecordId': 'Net-Suite Record ID',
        'bu': 'Business Unit',
    }
 
    // filter For Financial SPOC
    const isAllowedToEditDelete=(financialSpocs:any[])=>{
        let isAllowed :boolean=false;
        let userEmail = getUserDetails()?.email;
        if(writeAccess_order && UserProfile==="Admin" ){
            isAllowed = true;
        }
        else if(financialSpocs && financialSpocs.length>0  && writeAccess_order ){
                let _temp = financialSpocs.filter((item:any)=>item.email===userEmail);
                if(_temp.length>0){
                    isAllowed = true;
                }
        }
        return isAllowed;
    }

    return (
        <>
            <div className='DataTable'>
                <div className="DataTableForParentId table-container" style={containerStyle}>
                    <table style={tableStyle}>
                        <thead >
                            <tr>
                                <th style={{ ...thStyle, 'zIndex': '11', boxShadow: '-5px 0px 5px rgba(255, 255, 255, 1)' }} data-fixed="left"
                                 className="ant-table-column-has-actions ant-table-column-has-filters"
                                 >
                                {/* Work Order ID */}
                                    <span className="ant-table-header-column">
                                        <div>
                                            <span className="ant-table-column-title">
                                                Work Order ID
                                            </span>
                                            <SearchOutlined  style={{ margin: '10px', color: searchText?.id ? 'rgb(24, 144, 255)' : 'inherit' }} onClick={(e:any) => toggleSearchBar('id', e)}/> 
                                            {/* <Icon type="search" style={{ margin: '10px', color: searchText?.parentId ? 'rgb(24, 144, 255)' : 'inherit' }} onClick={(e:any) => toggleSearchBar('parentId', e)} /> */}
                                        </div>
                                    </span>
                                </th>
                                {renderSearchColumn({ id: 'sowId', name: 'SOW ID' })}
                                {/* <th style={thStyle}>SOW ID</th> */}
                                <th style={thStyle}>SOW Name</th>
                                {/* <th style={thStyle}>Client Entity</th> */}
                                {/* <th style={thStyle}>Indegene Entity</th> */}
                                {renderSearchColumn({ id: 'clientEntity', name: 'Client Entity' })}
                                {renderSearchColumn({ id: 'indegeneEntity', name: 'Indegene Entity' })}
                                {renderSearchColumn({ id: 'currency', name: 'Currency' })}
                                {renderSearchColumn({ id: 'geographyCode', name: 'Geography Code' })}
                                {/* {renderSearchColumn({ id: 'nsParentRecordId', name: 'Net-Suite Record ID' })} */}

                                <th style={thStyle} colSpan={5}>
                                    <table className='buCombTable'>
                                        <thead>
                                            <tr>
                                                {/* <th>Business Unit</th> */}
                                                {renderSearchColumn({ id: 'bu', name: 'Business Unit' })}
                                                {renderSearchColumn({ id: 'department', name: 'Department' })}
                                                {renderSearchColumn({ id: 'subDepartment', name: 'Sub-Department' })}
                                                {/* {renderSearchColumn({ id: 'classCode', name: 'Class Code' })} */}
                                                {/* <th>Department</th> */}
                                                {/* <th>Sub-Department</th> */}
                                                {/* <th>Class Code</th> */}
                                                {/* <th>Primary Class Code</th> */}
                                                <th>TCV Split</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </th>
                                <th  style={thStyle}> Total Contract Value </th>
                                <th  style={thStyle}> {'Total Contract Value (USD)'} </th>
                                <th  style={thStyle}> Financial SPOC</th>
                                <th style={thStyle}>Parent ID</th>
                                {/* <th style={thStyle}>Purchase Orders</th> */}
                                <th style={thStyle}>Invoice Schedule</th>
                                <th style={thStyle} data-fixed="right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedData.length > 0 ? displayedData.map((parentRow:any, parentIndex:any) => (
                                <React.Fragment key={parentIndex}>
                                    <tr>
                                        <td data-fixed='left' style={tdStyle}>{parentRow.id}</td>
                                        <td>{parentRow.sowId}</td>
                                        <td>{parentRow.sowName}</td>
                                        <td>{parentRow.clientEntity}</td>
                                        <td>{parentRow.indegeneEntity}</td>
                                        <td>{parentRow.currency}</td>
                                        <td>{parentRow.geographyCode}</td>
                                        {/* <td>{parentRow.nsParentRecordId ? parentRow.nsParentRecordId : '-'}</td> */}
                                        <td colSpan={5} className='buCombTable'>
                                            <table>
                                                <tbody>
                                                    {parentRow.workOrderBuDepartments.map((childRow:any, childIndex:any) => (
                                                        <tr key={childIndex}>
                                                            <td>{childRow.bu}</td>
                                                            <td>{childRow.department}</td>
                                                            <td>{childRow.subDepartment}</td>
                                                            {/* <td>{childRow.classCode}</td> */}
                                                            {/* <td>{childRow.primaryClassCode}</td> */}
                                                            <td>{childRow.tcvSplit}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>{parentRow?.tcvAmount}</td>
                                        <td>{parentRow?.tcvAmountUsd}</td>
                                        <td>{parentRow?.financialSpocs?.map((finspoc:any, index:any) => (<><span>{finspoc?.name}</span><br/></>))}</td>
                                        <td>
                                            
                                            {parentRow.parentId ? parentRow.parentId:
                                            parentRow.failedMsgForParentId?
                                            <>
                                            <Tooltip title={<div>
                                            <span>Error Details</span> <br/>
                                            <p>{parentRow.failedMsgForParentId} </p>
                                            </div>}>
                                            <span style={{color:'red'}}>Failed  <InfoCircleOutlined/></span><br/>
                                            </Tooltip>
                                            <Link className='maplink' onClick={()=>props.handleParentIdTrigger(parentRow)}><ReloadOutlined /> Retry</Link>
                                            </>:null}
                                            </td>
                                        {/* <td>{parentRow.mappedPos.map((po:any, index:any) => (<><span>{po}</span><br/></>))}
                                        </td> */}
                                        <td>
                                            {parentRow.invoiceScheduleAvailable ? (
                                                <>
                                                    <span>Y</span>{' '}
                                                    <Tooltip title="View Invoice Schedule">
                                                        <EyeOutlined style={{ cursor: 'pointer', color: '#034EA2' }} onClick={() => toggleScheduleView(parentRow.id)} />
                                                    </Tooltip>
                                                </>
                                            ) : 'N'}
                                        </td>
                                        <td data-fixed='right'>
                                        {/* <Tooltip title={!writeAccess_order ? "Only Accessible by the Role : Ops Lead": parentRow.parentId?"":"To map/unmap PO, parent Id is required." } >
                                            <Link className='maplink' disabled={!writeAccess_poMapping ? true: parentRow.parentId?false:true} onClick={()=>props.handleMapUnmapPO(parentRow)}>Map/Unmap PO</Link></Tooltip>
                                            <br/> */}
                                            <Tooltip title={!isAllowedToEditDelete(parentRow.financialSpocs) && "Only Accessible by the Role : Financial SPOC	" } >
                                            <Link className='maplink' disabled={!isAllowedToEditDelete(parentRow.financialSpocs)} onClick={()=>props.handleEditWorkOrder(parentRow)}>Edit</Link></Tooltip>
                                            <br/>
                                            <Tooltip title={!isAllowedToEditDelete(parentRow.financialSpocs) && "Only Accessible by the Role : Financial SPOC"}>
                                            <Popconfirm title="Are you sure you want to delete this work order?" disabled={!isAllowedToEditDelete(parentRow.financialSpocs)} onConfirm={()=>props.handleDeleteWorkOrder(parentRow)} okText="Yes" cancelText="No">
                                            <Link className='maplink' disabled={!isAllowedToEditDelete(parentRow.financialSpocs)} onClick={()=>null}>Delete</Link>
                                            </Popconfirm>
                                            </Tooltip>
                                            <br/>
                                            <Link className='maplink' onClick={()=>props.handleWorkOrderHistory(parentRow)}>History</Link>
                                        </td>
                                    </tr>
                                    {expandedScheduleIds[parentRow.id] && parentRow.invoiceSchedule && (
                                        <tr>
                                            <td colSpan={18} style={{ background: '#f5f8fa' }}>
                                                {/* sticky + translateX keeps the schedule visible while the wide table scrolls horizontally */}
                                                <div style={{ position: 'sticky', left: '50%', transform: 'translateX(-50%)', width: 'fit-content', maxWidth: '95vw', padding: '10px 10px 10px 20px' }}>
                                                    <div style={{ font: 'normal normal bold 13px/18px Nunito Sans', color: '#034EA2', marginBottom: '8px' }}>Invoice Schedule — {parentRow.id} ({scheduleTypeLabel(parentRow.invoiceSchedule.scheduleDescription)})</div>
                                                    <table className='invoiceScheduleTable'>
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th>Description</th>
                                                                <th>Invoice Date</th>
                                                                {parentRow.invoiceSchedule.percentageAvailable && <th>Percentage (%)</th>}
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {parentRow.invoiceSchedule.installments?.map((item: any, idx: any) => (
                                                                <tr key={idx}>
                                                                    <td>{scheduleTypeLabel(parentRow.invoiceSchedule.scheduleDescription)}</td>
                                                                    <td>{item.description}</td>
                                                                    <td>{item.invoiceDate ? String(item.invoiceDate).slice(0, 10) : '—'}</td>
                                                                    {parentRow.invoiceSchedule.percentageAvailable && <td>{item.percentage ?? '—'}</td>}
                                                                    <td>{item.amount ?? '—'}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                                :
                                <tr>
                                    <td colSpan={15}> <Empty /></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <Pagination
                    current={currentPage}
                    total={filterData().length}
                    pageSize={itemsPerPage}
                    onChange={handleChangePage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                />

                {modalVisible && (
                    <div>
                        <div
                            className="ant-dropdown-datable ant-dropdown-placement-bottomRight"
                            style={{
                                top: modalPosition.top, left: modalPosition.left,
                            }}
                        >
                            <div className="ant-table-filter-dropdown">
                                <div style={{ padding: 8 }}>
                                    <Input
                                    ref={searchInputRef}

                                    style={{ width: 188, marginBottom: 8, display: "block" }}
                                    placeholder={`Search ${placeHolders[clickedColumnRef.current] || ''}`}
                                    value={searchText[clickedColumnRef.current]}
                                    onChange={(e) => handleSearch(e, clickedColumnRef.current)}
                                    onKeyDown={(e) => {
                                        if (e.keyCode === 13) {
                                            searchForColumn(clickedColumnRef.current);
                                        }
                                    }}/>
                                    <Button type="primary" 
                                        style={{ width: 90, marginRight: 8 }}
                                        icon={<SearchOutlined />}
                                        onClick={() => {
                                            searchForColumn(clickedColumnRef.current);
                                        }}>
                                        Search
                                    </Button>
                                    <Button 
                                        style={{ width: 90 }}
                                        onClick={()=>resetSearch(clickedColumnRef.current)}
                                        >
                                        Reset
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default DataTable;
